import { Input } from './Input'

// Select reuses Input's sizes/variants. Because Input's outline variant reads
// `props.theme.textStyles`, Select's type is flag-aware too — it rides the Canvas type
// ramp flag-ON alongside the other form fields.
export const Select = {
  baseStyle: {
    icon: {
      fontSize: '1.5rem',
      color: 'gray.400'
    }
  },
  sizes: Input.sizes,
  variants: Input.variants,
  defaultProps: Input.defaultProps
}
